import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import queryClient from 'queries';


export interface TypedSeating {
    id?: string;
    seating_name?: string;
    seating_description?: string;
    seating_number?: number;
    seating_map?: string; /** Mấy tầng ghế, ghế nào mấy hàng mấy cột cái gì thế nào */
    seating_available?: string; /** Ghế nào bán ghế nào hủy */
    seating_available_count?: number;
    seating_status?: number; /** seating */
    createdAt?: string;
}



type IQuery = TypedSeating & IQueryParams;


/*
* List of all app
*/
export function useGetSeatings(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["seating/fetch_entity_list"],
        queryFn: () => axios.get<TypedSeating[]>(`/seating${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                body: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: true,
    });
}



export function useGetSeating(seating_id: string) {
    return useQuery({
        queryKey: ['seating/fetch_entity'],
        queryFn: () => axios.get<TypedSeating>(`/seating/${seating_id}`).then((response) => response.data),
        retry: 1,
        // enabled: false,
    });
}


export function useMutateGetSeatings() {
    return useMutation({
        mutationKey: ['seating/fetch_entity_list'],
        mutationFn: (object: IQuery) => axios.get<TypedSeating>(`/seating/${helpers.buildEndUrl(object)}`).then((response) => response.data),
    });
}

export function useMutateGetSeating() {
    return useMutation({
        mutationKey: ['seating/fetch_entity'],
        mutationFn: (seating_id: any) => axios.get<TypedSeating>(`/seating/${seating_id}`).then((response) => response.data),
    });
}


export function useUpdateSeating() {
    return useMutation({
        mutationKey: ['seating/update_entity'],
        mutationFn: ({ id, ...rest }: TypedSeating) => axios.patch<TypedSeating>(`/seating/${id}`, helpers.cleanEntity(rest)).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['seating/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['seating/fetch_entity'] });
        }
    });
}


export function useMutateCreateSeating() {
    return useMutation({
        mutationKey: ['seating/create_entity'],
        mutationFn: (entity: TypedSeating) => axios.post<TypedSeating>(`/seating`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['seating/fetch_entity_list'] });
        }
    });
}

export function useMutateDeleteSeating() {
    return useMutation({
        mutationKey: ['seating/create_entity'],
        mutationFn: (id: any) => axios.delete<TypedSeating>(`/seating/${id}`).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['seating/fetch_entity_list'] });
        }
    });
}